import { useEffect, useState } from "react";

type ThemeMode = "work" | "manga";

const STORAGE_KEY = "mangaos-theme";

function getInitialTheme(): ThemeMode {
  if (typeof window === "undefined") return "work";
  const saved = window.localStorage.getItem(STORAGE_KEY);
  return saved === "manga" ? "manga" : "work";
}

export default function ThemeToggleButton() {
  const [theme, setTheme] = useState<ThemeMode>(getInitialTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    window.localStorage.setItem(STORAGE_KEY, theme);
    window.dispatchEvent(new Event("mangaos-theme-change"));
  }, [theme]);

  return (
    <button
      type="button"
      className="btn btn-outline btn-sm theme-toggle-btn"
      onClick={() => setTheme((current) => (current === "work" ? "manga" : "work"))}
      title={theme === "work" ? "Manga UIに切り替えます" : "実務UIに戻します"}
    >
      {theme === "work" ? "Manga Mode" : "Work Mode"}
    </button>
  );
}
